import script from "./account.vue?vue&type=script&setup=true&lang=js"
export * from "./account.vue?vue&type=script&setup=true&lang=js"

import "./account.vue?vue&type=style&index=0&id=934e69ce&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-934e69ce"]])

export default __exports__